var _circle, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditorIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 74,
    viewBox: "0 0 86 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 44.5,
    r: 29.5,
    fill: "#0A0821"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "#08A045"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8937 14.6382V54.8624H28.4471C27.2094 51.5916 26.532 48.0455 26.532 44.3411C26.532 28.3794 39.1091 15.3553 54.8937 14.6382Z",
    fill: "#CEFDE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorIllustration);
export default __webpack_public_path__ + "static/media/editorIllustration.0325a4c80736180fcfb94490b68bdcda.svg";
export { ForwardRef as ReactComponent };